import SubTable from 'src/components/commons/subTable';
import PageContainer from 'src/components/pageContainer/PageContainer';
import { CustomLoadingModal } from 'src/components/commons/customModal';
import useProductFamilyTable from './hooks/useProductFamilyTable';
import StyleInfinityScroll from '../../../../styles/StyleInfinityScroll.style';

const TabProductFamily = () => {
  const {
    dataSource,
    columns,
    spinning,
    newRecord,
    autoCompleteFieldSearch,
    handleFilterChange,
    setColumns,
    onListRender,
    handleDeleteRows,
    postNewRecord,
    resetNewRecord,
    handleUpdateRows,
    handleNewRecord,
    handleClearFilter,
  } = useProductFamilyTable();

  return (
    <>
      {spinning && <CustomLoadingModal modalStatus />}
      <PageContainer margin='2rem'>
        <StyleInfinityScroll>
          <SubTable
            data={dataSource || []}
            columns={columns}
            setColumns={setColumns}
            onListRender={onListRender}
            onFilterChange={handleFilterChange}
            autocompleteFieldProvider={autoCompleteFieldSearch}
            columnFilterShown
            scroll={{ y: '60vh', x: '90vw' }}
            clearFilter={handleClearFilter}
            actionCell={['delete']}
            headerActions={['filter', 'edit', 'delete']}
            id='product-family-table'
            showOptionFilterLeft={false}
            allowGlobalEditActive
            activeOnSelectRowsDisableEdit
            total
            showAutoIncrement
            newRecord={newRecord}
            resetNewRecord={resetNewRecord}
            handleUpdateRows={handleUpdateRows}
            onDeleteClick={handleDeleteRows}
            saveNewRecord={postNewRecord}
            postData={handleNewRecord}
          />
        </StyleInfinityScroll>
      </PageContainer>
    </>
  );
};

export default TabProductFamily;
